import { createContext } from 'react';
import { CaseDetailsLawyer } from '@/interfaces';

export interface SaveStatusState {
	isSaving: boolean;
	isError: boolean;
	lastSavedAt?: Date;
}

interface CaseContext {
	caseDetails: CaseDetailsLawyer | undefined;
	isCaseReadOnly: boolean;
	saveStatus: SaveStatusState;
	setSaveStatus: (status: Partial<SaveStatusState>) => void;
}

export const CaseContext = createContext<CaseContext>({
	caseDetails: undefined,
	isCaseReadOnly: false,
	saveStatus: {
		isSaving: false,
		isError: false,
	},
	setSaveStatus: () => {},
});
